import * as packageInfo from '../../../package/package.json';

export const name = packageInfo.name;
export const version = packageInfo.version;

